import { cdnImageUrl } from 'helpers/image'
import React, { FC } from 'react'
import styled from 'styled-components'
import ImageBox from 'uiComponents/atoms/ImageBox/ImageBox'
import { complementaryColor } from 'uiComponents/constants/colors'
import { fsM, fsXXXL, fwHeavy } from 'uiComponents/constants/typography'

export const DropDetailsBrandImage: FC<{
  brandImage: string | undefined
  headline: string | undefined
  subline: string | undefined
}> = ({ brandImage, headline, subline }) => {
  return (
    <StyledBrandWrapper>
      <StyledBrandTitle>{subline}</StyledBrandTitle>
      {!brandImage && headline && <BrandText>{headline}</BrandText>}
      {brandImage && (
        <StyledBrandImage
          src={cdnImageUrl(brandImage, {
            transparent: true,
            width: 400,
            height: 200,
          })}
        />
      )}
    </StyledBrandWrapper>
  )
}

const StyledBrandWrapper = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  right: 0;
  transform: translate(-50%, -50%);
  max-width: 400px;
  text-align: center;
`

const StyledBrandTitle = styled.h3`
  color: ${complementaryColor};
  ${fwHeavy};
  font-size: ${fsM}px;
  line-height: 3;
`

const StyledBrandImage = styled(ImageBox)`
  height: auto;
`

const BrandText = styled.h2`
  font-size: ${fsXXXL}px;
  letter-spacing: 0.6px;
  color: ${complementaryColor};
`
